"use strict";
var header = document.getElementById('my-header'), headerHeight = header ? header.offsetHeight : 76, pageContent = document.getElementById('my-page');
// Publishes the height anchors have to clear, which the stylesheet applies as
// scroll-padding-top. Nothing to clear unless the header is floating.
function publishHeaderOffset() {
    if (!header || getComputedStyle(header).position !== 'fixed') {
        document.documentElement.style.removeProperty('--header-height');
        return;
    }
    // Once the page is scrolled the header carries header--small, so that is the size
    // it will have when an anchor arrives. Measure in that state, then put the class
    // back before the browser draws anything.
    var wasSmall = header.classList.contains('header--small');
    header.classList.add('header--small');
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    header.classList.toggle('header--small', wasSmall);
}
function addPaddingToPage() {
    if (window.matchMedia('(max-width: 767px)').matches &&
        header &&
        pageContent) {
        pageContent.style.marginTop = headerHeight + 'px';
    }
    else {
        pageContent.removeAttribute('style');
    }
}
document.addEventListener('DOMContentLoaded', addPaddingToPage);
window.addEventListener('resize', addPaddingToPage);
document.addEventListener('DOMContentLoaded', publishHeaderOffset);
window.addEventListener('resize', publishHeaderOffset);
window.addEventListener('scroll', function () {
    if (window.pageYOffset > 200) {
        header.classList.add('header--small');
    }
    else {
        header.classList.remove('header--small');
    }
});
